import React from 'react';

export const PERMISSIONS = {
    PRODUCT_CREATE: 'product.create',
    PRODUCT_EDIT: 'product.edit',
    PRODUCT_SHOW: 'product.show',
    PRODUCT_LIST: 'product.list',
    PRODUCT_ORDER: 'product.order',
    PRODUCT_COST: 'product.cost',
    CATEGORY_CREATE: 'category.create',
    CATEGORY_EDIT: 'category.edit',
    CATEGORY_SHOW: 'category.show',
    CATEGORY_LIST: 'category.list',
    CATEGORY_REORDER: 'category.reorder',
    CUSTOMER_CREATE: 'customer.create',
    CUSTOMER_EDIT: 'customer.edit',
    CUSTOMER_SHOW: 'customer.show',
    CUSTOMER_LIST: 'customer.list',
    CUSTOMER_DELETE: 'customer.delete',
    CUSTOMER_EXPORT: 'customer.export',
    CUSTOMER_REPORT: 'customer.report',
    CUSTOMER_PRINT_EDIT: 'customer.printEdit',
    CUSTOMER_PHONE: 'customer.phone',
    CUSTOMER_WHATSAPP: 'customer.whatsapp',
    ORDER_EDIT: 'order.edit',
    ORDER_SHOW: 'order.show',
    ORDER_LIST: 'order.list',
    ORDER_CREATE: 'order.create',
    ORDER_CANCEL: 'order.cancel',
    ORDER_PRINT: 'order.print',
    ORDER_RECONCILED: 'order.reconciled',
    ORDER_AUTOSAVE_COMMENT: 'order.autoSaveComment',
    OFFICE_CREATE: 'office.create',
    OFFICE_EDIT: 'office.edit',
    OFFICE_SHOW: 'office.show',
    OFFICE_LIST: 'office.list',
    BILL_CREATE: 'bill.create',
    BILL_EDIT: 'bill.edit',
    BILL_SHOW: 'bill.show',
    BILL_LIST: 'bill.list',
    BILL_CHANGE_ORDER: 'bill.changeOrder',
    POSTSALE_CREATE: 'postsale.create',
    POSTSALE_EDIT: 'postsale.edit',
    POSTSALE_SHOW: 'postsale.show',
    POSTSALE_LIST: 'postsale.list',
    POSTSALE_SYNC: 'postsale.sync',
    POST_SALE_REPORT: 'postsale.report',
    POSTSALE_RECEIVED: 'postsale.received',
    PAYMENT_CREATE: 'payment.create',
    PAYMENT_EDIT: 'payment.edit',
    PAYMENT_SHOW: 'payment.show',
    PAYMENT_LIST: 'payment.list',
    REPORT_CREATE: 'report.create',
    REPORT_EDIT: 'report.edit',
    REPORT_SHOW: 'report.show',
    REPORT_LIST: 'report.list',
    USER_CREATE: 'user.create',
    USER_EDIT: 'user.edit',
    USER_SHOW: 'user.show',
    USER_LIST: 'user.list',
    SECURITY_CREATE: 'security.create',
    SECURITY_EDIT: 'security.edit',
    SECURITY_SHOW: 'security.show',
    SECURITY_LIST: 'security.list',
    SECURITY_TOKEN: 'security.token',
    LOCALITY_CREATE: 'locality.create',
    LOCALITY_EDIT: 'locality.edit',
    LOCALITY_SHOW: 'locality.show',
    LOCALITY_LIST: 'locality.list',
    TEMPLATE_CREATE: 'template.create',
    TEMPLATE_EDIT: 'template.edit',
    TEMPLATE_SHOW: 'template.show',
    TEMPLATE_LIST: 'template.list',
    RESOLUTION_CREATE: 'resolution.create',
    RESOLUTION_EDIT: 'resolution.edit',
    RESOLUTION_SHOW: 'resolution.show',
    RESOLUTION_LIST: 'resolution.list',
    CONFIG_CREATE: 'config.create',
    CONFIG_EDIT: 'config.edit',
    CONFIG_SHOW: 'config.show',
    CONFIG_LIST: 'config.list',
    COMMENT_CREATE: 'comment.create',
    COMMENT_EDIT: 'comment.edit',
    COMMENT_SHOW: 'comment.show',
    COMMENT_LIST: 'comment.list',
    COMMENT_DELETE: 'comment.delete',
    ORDER_PERSONAL: 'order.personal',
    OFFICE_DOWNLOAD: 'office.download',
    BILL_DOWNLOAD: 'bill.download',
    POSTSALE_DOWNLOAD: 'postsale.download',
    CATEGORY_DOWNLOAD: 'category.download',
    DELIVERY_LOCALITY_CREATE: 'deliverylocality.create',
    DELIVERY_LOCALITY_EDIT: 'deliverylocality.edit',
    DELIVERY_LOCALITY_SHOW: 'deliverylocality.show',
    DELIVERY_LOCALITY_LIST: 'deliverylocality.list',
    WALLET_CREATE: 'wallet.create',
    WALLET_EDIT: 'wallet.edit',
    WALLET_SHOW: 'wallet.show',
    WALLET_LIST: 'wallet.list',
    ITEMS_CREATE: 'items.create',
    ITEMS_EDIT: 'items.edit',
    ITEMS_SHOW: 'items.show',
    ITEMS_LIST: 'items.list',
    CATALOG_SYNC: 'catalog.sync',
    DASHBOARD_TOTALS: 'dashboard.totals',
    DASHBOARD_INVENTORY: 'dashboard.inventory',
    DASHBOARD_ORDER_STATUS: 'dashboard.orderStatus',
    VCARD_MANAGE: 'vcard.manage',
    VCARD_EXPORT: 'vcard.export',
    DASHBOARD_ALARMS: 'dashboard.alarms',
    SALES_AMOUNT: 'sales.amount',
};
export const hasPermissionAccess = (roles, permission) => {
    return true;
    //return roles.includes(permission);
}
